module.exports = __webpack_public_path__ + "static/img/fs1-3.4d44d24.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/SaveFile/fs1-3.png
// module id = 843
// module chunks = 0